import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

// Drop-in replacement for the old useAuth0(). Exposes the same surface the app
// already consumed - isAuthenticated, isLoading, user, loginWithRedirect,
// logout, getAccessTokenSilently - backed by the Avalanche session JWT issued
// from a QuestionPro OAuth login.
export default function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
